import { render, staticRenderFns } from "./Comprar.vue?vue&type=template&id=0dcb4a3c&scoped=true"
import script from "./Comprar.vue?vue&type=script&lang=js"
export * from "./Comprar.vue?vue&type=script&lang=js"
import style0 from "./Comprar.vue?vue&type=style&index=0&id=0dcb4a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb4a3c",
  null
  
)

export default component.exports